module.exports = __webpack_public_path__ + "img/ubnKSIfAJTxIgXOKlciN.53c840d8.png";